export default __webpack_public_path__ + "static/media/sub-banner-num-3.bf88eb53.svg";